var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4",
    "data-name": "Group 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M3.122,6.316a3.431,3.431,0,0,0,1.614-.424,3.093,3.093,0,0,0,1.124-4.3A3.058,3.058,0,0,0,1.58.458,3.141,3.141,0,0,0,.456,4.831,3,3,0,0,0,3.122,6.316Z",
    transform: "translate(50.526 13.684)",
    fill: "#02aca0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M1.538,5.893a3.289,3.289,0,0,0,1.62.423A3.134,3.134,0,0,0,5.9,4.7,3.172,3.172,0,0,0,4.776.411,3.269,3.269,0,0,0,.41,1.537,3.259,3.259,0,0,0,1.538,5.893Z",
    transform: "translate(40 3.158)",
    fill: "#02aca0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M30,60A30,30,0,0,0,60,30a3.007,3.007,0,1,0-6.014,0A23.986,23.986,0,1,1,30,6.014,3.007,3.007,0,1,0,30,0a30,30,0,1,0,0,60Z",
    fill: "#02aca0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadIc);
export default __webpack_public_path__ + "static/media/load-ic.a17ff2375ed3e685c17f0137aa7b711f.svg";
export { ForwardRef as ReactComponent };